export default "__VITE_ASSET__CvDyQVeY__"